module.exports = __webpack_public_path__ + "img/404.78bb75e5.png";